<template>
  <div class="editActive">
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>活动/新增活动</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row>
      <el-col :span="formW" :offset="formSpn">
        <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="activeForm" :label-position="labelP" size="small" :label-width="labelW">
          <el-form-item label="上传活动图片：" prop="atyPictureUrl">
            <Upload :mediaUrl.sync="form.atyPictureUrl" :typeString = '"A"' />
            <el-input v-model="form.atyPictureUrl" style="display:none;"></el-input>
          </el-form-item>
          <el-form-item label="活动主题："  prop="atyTheme">
            <el-input v-model="form.atyTheme" ></el-input>
          </el-form-item>
          <el-form-item label="活动时间：" v-if="isPC" prop="atyDate">
              <el-date-picker
                style="text-align:left;"
                v-model="form.atyDate"
                type="datetime">
              </el-date-picker>
          </el-form-item>
          <el-form-item v-else label="活动时间：" prop="atyDate">
            <el-input v-model="form.atyDate" style="display:none;"></el-input>
            <input v-model="form.atyDate" class="minput" placeholder="请选择活动时间" :readonly="true" @click="showCalendar"/>
            <vue-hash-calendar format="YY/MM/DD hh:mm" style="z-index:10000" :visible.sync="isShowCalendar" model="dialog" @confirm="confirmCalendar"></vue-hash-calendar>
          </el-form-item>
          <el-form-item label="活动地点："  prop="atyPlace">
            <el-input v-model="form.atyPlace"></el-input>
          </el-form-item>

          <el-form-item class="noborder" label="活动描述："  prop="atyContent">
            <el-input type="textarea" rows="4" v-model="form.atyContent"></el-input>
          </el-form-item>

          <el-form-item class="btns noborder" v-if="isPC">
            <el-button size="medium" type="primary" @click="onSubmit">提交</el-button>
            <el-button size="medium" @click="back">返回</el-button>
          </el-form-item>
        </el-form>
        <div style="text-align:center;" v-if="!isPC">
          <el-button size="medium" type="primary" @click="onSubmit">提交</el-button>
          <el-button size="medium" @click="back">返回</el-button>
        </div>
      </el-col>
    </el-row>
    
  </div>
</template>
<script>
import api from '@/api'
import Upload from '@/components/Upload'
import tools from '@/utils/tools';
export default {
  data () {
    return {
        "id": `${this.$route.query.id}` === 'undefined' ? '' : `${this.$route.query.id}`,
        saveBtnStatue:false,  //保存铵钮状态
        form: {
            "atyID": 0,
            "atyType": 0,
            "atyTheme": "",
            "atyContent": "",
            "atyDate": '',  
            "atyBTime": "",
            "atyETime": "",
            "atyPlace": "",
            "atySpeaker": "",
            "atyQuota": 0,
            "atyUrl": "",
            "atyObj": "",
            "atyPrice": 0,
            "atyDateTime": "",
            "atyETheme": "",
            "atyEContent": "",
            "atyEPlace": "",
            "atyESpeaker": "",
            "atyEDateTime": "",
            "atylimit": 0,
            "atyPoint": 0,
            "atyRecommend": true,
            "atySponsorTitle": "",
            "atySponsorETitle": "",
            "atyPictureUrl": "",
        },
        classTypeList:[],
        rules: {
          atyPictureUrl: [{ required: true, message: '请上传活动图片', trigger: 'change' }],
          atyTheme: [{ required: true, message: '请填写活动主题', trigger: 'change' }],
          atyDate: [{ required: true, message: '请填写活动时间', trigger: 'change' }],
          atyPlace: [{ required: true, message: '请填写活动地点：', trigger: 'change' }],
          atyContent: [{ required: true, message: '请填写活动描述', trigger: 'change' }],
        },
        isPC: true,
        formW: 18,
        formSpn: 2,
        labelW: '200px',
        labelP: 'right',
        isShowCalendar: false
      }
  },

  components: {
    Upload
  },
  mounted() {
    this.isPC = tools.isPC()
    if (!this.isPC) {
      this.formW = 24
      this.formSpn = 0
      this.labelP = 'left'
      this.labelW = '135px'
    }
    if (this.id !='') {
        api.getactivitydetail({atyID : parseInt(this.id) }).then((res)=>{
            if(res.data.code =='200'){
              var _data = res.data.data
              this.form.atyID =  _data.atyID
              this.form.atyPictureUrl =  _data.atyPictureUrl
              this.form.atyTheme = _data.atyTheme
              this.form.atyDate =   _data.atyDate
              this.form.atyPlace =  _data.atyPlace
              this.form.atyContent =  _data.atyContent
            }
        })
    }
  },

  methods: {
    confirmCalendar(data) {
      this.form.atyDate = data
    },
    showCalendar() {
      this.isShowCalendar = true
    },
    onSubmit() {
      if( this.saveBtnStatue ){
          return false
      }
      this.$refs['activeForm'].validate((valid) => {
        if (valid) {
          var paramt = JSON.parse(JSON.stringify(this.form))
          if(this.atyID !=''){
            paramt.atyID = parseInt( this.id)
          }
          paramt.atyDate = tools.formatDate(paramt.atyDate ,'yyyy-MM-dd hh:mm:ss') 
          paramt.atyID = parseInt(this.form.atyID) 

            this.saveBtnStatue = true
          api.saveactivity(paramt).then((res) => {
            if (res.data.code === 200) {
                this.$notify({
                  title: '保存成功',
                  type: 'success'
                })
                this.$router.go(-1)
            }
            this.saveBtnStatue = false
          })
        } else {
          return false
        }
      })
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less">
.editActive{
  .blue {
    color: #409eff;
  }

  .title {
    margin-bottom: 30px;
  }

  .col-1-fix {
    padding-left: 0 !important;
  }
  .desc{
    font-size: 14px;
    line-height: 18px;
    padding: 10px;
  }
  .mz{
    font-size:14px;
    color:#999;
  }
  .btns{
    text-align: center;
    padding-top: 15px;
  }
  @media screen and (max-width:540px){
    .minput{
      height: 32px;
      line-height: 32px;
      text-align: right;
      font-size: 14px;
      color:#606266;
      border:0;
      width: 98%;
    }
    .dash-upload{
      width:160px;
    }
    .el-input__inner{
      border:0;
      text-align: right;
    }
    .el-form-item{
      border-bottom:1px solid #DCDFE6;
    }
    .noborder{
      border:0;
    }
    .el-form-item--small .el-form-item__error{
      text-align: right;
      width: 100%;
    }
  }
}
</style>
